// extracted by mini-css-extract-plugin
export var changeIcon = "_55-4";
export var container = "_55-0";
export var divider = "_55-7";
export var externalLinkIcon = "_55-1";
export var green = "_55-5";
export var helpCircleIcon = "_55-3";
export var iconButton = "_55-2";
export var red = "_55-6";